import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ListLoader from "../../../CustomComponents/AllLoader/ListLoader";
import OrderPostPagination from "../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import {
  formatNumberWithCommas,
  getJobPriceWithLabel,
  getRemaindays,
} from "../../../Common/AllDateTimeReleventFormate";
import { getMyOrderJobList } from "../../../../redux/job/action";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function PaginationforJobsCompleted() {
  const path = "Assets/scss/myorders.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const myorderjoblist = useSelector(
    ({ job: { myorderjoblist } }) => myorderjoblist,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyOrderJobList(3, pageNumber, 10, 23));
  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(myorderjoblist?.response) && (
            <>
              <h4>
                Completed Part time Job (PTJ)
                <OrderPostPagination
                  totalitemcounts={myorderjoblist?.count}
                  size={10}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </h4>
              {myorderjoblist?.length == 0 && <ListLoader />}
              <div className="recent-post row recent-job">
                {myorderjoblist?.response.map((item, index) => (
                  <div className="col-md-6" key={item.id}
                    onClick={() =>
                      navigate(`/${lan}/dashboard/myorders/job/active/${item.id}`)
                    }>
                    <div className="post-back recent-back">
                      <div className="recent-detail">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                            alt=""
                          />
                          Job type:
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                        <h3>{decodeHtml(item?.title)}</h3>
                        <h1>
                          {`$${formatNumberWithCommas(item?.payment_recieved)}`}
                          {/* {
                            item?.status == 23 ? `$${formatNumberWithCommas(item?.payment_recieved)}` :
                              getJobPriceWithLabel(item?.proposed_price, item?.hiring_type)} */}
                        </h1>
                      </div>
                      <div className="recent-detail">
                        <p>Logged hour</p>
                        <h3>{item?.logged_hours || 0} hrs</h3>
                      </div>
                      <button
                        onClick={() =>
                          navigate(
                            `/${lan}/dashboard/myorders/job/active/${item.id}`,
                          )
                        }
                        className="btn"
                      >
                        View details
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
